<!--
 * @Author: awu
 * @Date: 2020-11-12 23:28:55
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 19:51:22
 * @Description: file content
-->
<template>
    <div class="chat-wrapper">
        <div class="chat-container">
            <!-- <div class="chat-lists">
                <div class="chat-list" v-for="item in onLineUsers" :key="item.uid" @click="handleToggleChat(item)">
                    {{ item.name }}
                    <div class="badge" v-if="item.newMessageCount">{{ item.newMessageCount }}</div>
                </div>
            </div> -->
            <div class="chat-content">
                <div class="chat-header">
                    <div class="name">{{ companyName || "" }}</div>
                    <img @click="backHome" :src="require('@/assets/user/close.png')" alt="" />
                </div>
                <div class="chat-main" ref="chatMain">
                    <div :class="['chat-item', item.own ? 'right' : 'left']" v-for="item in threads[currentRemoteUid]" :key="item.currentTime">
                        <img :src="item.avatarUrl" alt="" class="avatar" />
                        <div class="text">{{ item.text }}</div>
                    </div>
                </div>
                <div class="chat-ipt">
                    <textarea v-model="text" @keyup.enter="send" :placeholder="$t('chat').pld" class="textarea"></textarea>
                    <div class="send" @click="send">发送</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AgoraRTM from "agora-rtm-sdk";
import { APPID } from "@/utils";
// import { exhibition_id } from "@/utils/exhibitId";
import { mapState } from "vuex";
import api from "@/api";

export default {
    name:"Chat",
    data() {
        return {
            currentRemoteUid: "",
            company_id: "",
            companyName: "",
            commonAvator: "http://himg.bdimg.com/sys/portrait/item/35a1e8bea3e4b98ce587a4e584bfd005.jpg",
            threads: {}, // 消息列表
            onLineUsers: [], // 左侧聊天列表
            text: "" // 发送文本
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        currentRemoteUser() {
            let item = this.onLineUsers.find((v) => v.uid === this.currentRemoteUid);
            return item || {};
        },
        userName() {
            return this.userInfo.nick_name;
        }
    },
    mounted() {
        // 观众
        this.company_id = this.$route.query.company_id;
        this.exhibition_id = this.$route.query.exhibition_id;
        this.userType = "Audience";
        this.client = AgoraRTM.createInstance(APPID);
        this.client.on("ConnectionStateChanged", (newState, reason) => {
            console.log("on connection state changed to " + newState + " reason: " + reason);
        });
        this.getCompanyInfo();
        this.getExhibitionDetali();
    },
    methods: {
        getExhibitionDetali() {
            // 获取公司详情
            api.getExhibitionDetali({
                id: this.company_id,
                params: {
                    exhibition_id: this.exhibition_id
                }
            }).then((res) => {
                if (res.res === 1) {
                    this.companyName = res.info.company.name;
                }
            });
        },
        getCompanyInfo() {
            api.getCompanyUid(this.company_id).then((res) => {
                if (res.res === 1) {
                    const { uid } = res.list[0];
                    this.currentRemoteUid = uid;
                    this.remoteUid = uid;
                    this.loginRtm();
                }
            });
        },
        loginRtm() {
            const { rtm_token, rtm_uid } = this.userInfo;
            this.client
                .login({ token: rtm_token, uid: rtm_uid })
                .then(() => {
                    if (this.userType !== "EXHIBITOR") {
                        this.onLineUsers.push({
                            uid: this.remoteUid,
                            avatarUrl: this.commonAvator,
                            name: this.companyName,
                            // deviceType: "pc",
                            newMessageCount: 0
                        });
                        this.threads[this.remoteUid] = [];
                    }
                    this.onListenMessage();
                })
                .catch((err) => {
                    // console.log("AgoraRTM client login failure", err);
                    // alert("连接服务器出错，请刷新页面重试！");
                });
        },
        onListenMessage: function() {
            // peerId 发送者的uid
            this.client.on("MessageFromPeer", (text, peerId) => {
                /* 收到点对点消息的处理逻辑 */
                // 渲染好友列表
                let peerExists = false;
                // 当前发消息的好友在数组中的index
                let speakingUserIndex = 0;
                let onLineUsers = this.onLineUsers;
                for (let i = 0; i < onLineUsers.length; i++) {
                    if (onLineUsers[i].uid === peerId) {
                        // TODO 好友已经存在，将消息存入已存在的消息队列
                        peerExists = true;
                        // 给当前用户的头像上加一个红点
                        ++onLineUsers[i].newMessageCount;
                        speakingUserIndex = i;
                        break;
                    }
                }
                let textData = JSON.parse(text.text);
                // 好友不在列表中
                if (!peerExists) {
                    onLineUsers.push({
                        uid: peerId,
                        avatarUrl: "http://himg.bdimg.com/sys/portrait/item/35a1e8bea3e4b98ce587a4e584bfd005.jpg",
                        name: textData.userName,
                        // deviceType: "pc",
                        newMessageCount: 1
                    });
                }
                // 置顶当前的好友
                /*
                    if (onLineUsers && onLineUsers.length > 0) {
                        const currentSpeakingUser = onLineUsers.splice(speakingUserIndex, 1)
                        onLineUsers.unshift(currentSpeakingUser)
                    }
                */
                // if (onLineUsers.length === 1) {
                //     this.remoteUid = peerId;
                // }
                // 渲染消息列表
                if (!this.threads[peerId]) {
                    this.threads[peerId] = [];
                }
                let date = new Date();
                this.threads[peerId].push({
                    own: false,
                    text: textData.text,
                    name: this.userName,
                    avatarUrl: this.commonAvator,
                    currentTime: new Date().getTime()
                });
                this.$forceUpdate();
                this.scrollFooter();
            });
        },
        scrollFooter() {
            let $list = this.$refs["chatMain"];
            if ($list) {
                this.$nextTick(() => {
                    $list.scrollTop = $list.scrollHeight;
                });
            }
        },
        send: function() {
            const text = this.text;
            if (text.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "") === "") {
                this.text = "";
                return;
            }
            const remoteUid = this.remoteUid;
            let date = new Date();
            this.client
                .sendMessageToPeer(
                    {
                        text: JSON.stringify({
                            text: text,
                            userName: this.userName
                        })
                    },
                    remoteUid,
                    {
                        enableHistoricalMessaging: true,
                        enableOfflineMessaging: true
                    }
                )
                .then((sendResult) => {
                    // 两种情况：1.(sendResult.hasPeerReceived)远端用户收到消息事件;2.服务器已收到消息，对端未收到消息，存为离线消息
                    this.threads[this.remoteUid].push({
                        own: true,
                        text,
                        avatarUrl: this.commonAvator,
                        currentTime: new Date().getTime()
                    });
                    this.text = "";
                    this.scrollFooter();
                })
                .catch((error) => {
                    alert("点对点消息发送失败,请稍后重试");
                });
        },
        backHome() {
            this.$root.$emit("close");
            this.$emit("cancel",6)
        },
        handleToggleChat(item) {
            if (item.uid !== this.currentRemoteUid) {
                this.currentRemoteUid = item.uid;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/var.scss";

.chat-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 6;
    transform: translate(-50%, -50%);
    background: #ffffff;
    box-shadow: 0px 5px 7px 3px rgba(0, 0, 0, 0.3);
    // border-radius: 20px;
    width: 100%;
    height: 100%;
    // min-width: 610px;
    // min-height: 400px;
    overflow: hidden;
    .chat-container {
        display: flex;
        height: 100%;
    }
    .chat-lists {
        font-size: .28rem;
        flex-shrink: 0;
        height: 100%;
        background: #f4f4f4;
        overflow-y: auto;
        color: rgba(9, 70, 140, 0.45);
        padding: .3rem .1rem;
        .chat-list {
            width: 3rem;
            height: .66rem;
            line-height: .66rem;
            white-space: nowrap;
            overflow: hidden;
            padding: 0 .26rem;
            text-overflow: ellipsis;
            cursor: pointer;
            font-weight: 500;
            position: relative;
            border-radius: 8px;
            &:hover {
                background: rgba(9, 70, 140, 0.1);
                color: rgba(9, 70, 140, 1);
            }
            &.active {
                background: rgba(9, 70, 140, 0.1);
                color: rgba(9, 70, 140, 1);
            }
            .badge {
                min-width:.32rem;
                height:.32rem;
                border-radius: 50%;
                background: #ea6767;
                border-radius: 8px;
                font-size: 11px;
                white-space: nowrap;
                line-height:.32rem;
                text-align: center;
                color: #fff;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
            }
        }
    }
    .chat-content {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        .chat-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .54rem;
            font-size: .4rem;
            color: #09468c;
            height: 1.24rem;
            border-bottom: 1px solid rgba(151, 151, 151, 1);
            font-size: .40rem;
            .name {
                flex: 1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: 500;
            }
            img {
                width: .6rem;
                height: .6rem;
                flex-shrink: 0;
                cursor: pointer;
            }
        }
        .chat-main {
            flex: 1;
            height: 0;
            padding: 0 .4rem .3rem;
            overflow-y: auto;
            .chat-item {
                display: flex;
                align-items: center;
                margin-top: 27px;
                &.right {
                    flex-direction: row-reverse;
                    .text {
                        margin-right: 13px;
                        margin-left: 0;
                        background-color: rgba(9, 70, 140, 1);
                    }
                }
                .avatar {
                    width: 33px;
                    height: 33px;
                    border-radius: 15px;
                }
                .text {
                    font-size: 14px;
                    color: #fff;
                    max-width: 60%;
                    padding: 9px 10px;
                    background: rgba(9, 70, 140, 0.45);
                    margin-left: 13px;
                    border-radius: 20px;
                    position: relative;
                }
            }
        }
        .chat-ipt {
            display: flex;
            background: rgba(9, 70, 140, 0.1);
            // border-radius: .36rem;
            width: 100%;
            align-items: center;
            textarea {
                outline: none;
                resize: none;
                color: rgba(9, 70, 140, 1);
                padding: .26rem .3rem;
                flex: 1;
                font-size: .28rem;
                background: transparent;
            }
            .send {
                width: 1.28rem;
                height: .48rem;
                line-height: .48rem;
                text-align: center;
                background: #09468c;
                border-radius: .18rem;
                font-size: .24rem;
                font-weight: 600;
                margin-right: .26rem;
                color: #fff;
                cursor: pointer;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobileChat/index.vue